import axios from 'axios';
export default {
  data() {
    return {
    };
  },
  // created: function() {
  //   this.IVRLogin();
  // },
  methods: {
    IVRLogin() {
          const options = {
            method: 'POST',
            url: 'https://api-smartflo.tatateleservices.com/v1/auth/login',
            headers: {accept: 'application/json', 'content-type': 'application/json'},
            data: {email: 'TACN3303', password: 'Admin@123456'}
          };
          axios
            .request(options)
            .then(function (response) {
              console.log(response.data);
              localStorage.setItem('IVRData',JSON.stringify(response.data))
              alert('Please try Again')
            })
            .catch(function (error) {
              console.error(error);
            });
          },
  }
};
